module.exports = __webpack_public_path__ + "img/img17.082c85ea.svg";